<div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="space-between end"
  [ngClass]="{'invisible-background': invisibleBackground}">
  <mat-form-field>
    <mat-icon mat-icon-button matPrefix>search</mat-icon>
    <input type="text" [(ngModel)]="paging.search" (input)="changeSearch(paging.search)"
      matTooltip="{{searchPlaceholder}}" matInput placeholder="{{searchPlaceholder}}">
  </mat-form-field>
  <mat-form-field *ngIf="!paging.pagingSearchOptions.noOrderOptions">
    <mat-label>{{filterByLabel}}</mat-label>
    <mat-select [(value)]="paging.orderBy" (selectionChange)="changeOrderBy($event.value)">
      <mat-option *ngFor="let option of paging.orderOptions" value="{{option.field}}">{{option.label}}</mat-option>
    </mat-select>
    <button *ngIf="showOrderArrow && paging.orderType === OrderType.asc" mat-icon-button matSuffix
      (click)="$event.stopPropagation(); changeOrderType(OrderType.desc)">
      <mat-icon>arrow_upward</mat-icon>
    </button>
    <button *ngIf="showOrderArrow && paging.orderType === OrderType.desc" mat-icon-button matSuffix
      (click)="$event.stopPropagation(); changeOrderType(OrderType.asc)">
      <mat-icon>arrow_downward</mat-icon>
    </button>
  </mat-form-field>
</div>